module.exports = __webpack_public_path__ + "img/activities-5.f93456b4.jpg";